/**
 * Applied as every Clarity fly-in overlay's `panelClass`.
 *
 * The same kind of seam as `CLARITY_DIALOG_PANEL_CLASS`, against a different stylesheet and a
 * sharper problem. `ui-styles`' `theme/design-schedule-theme.scss` is loaded globally into
 * `ui-kit-docs`, and its `.cdk-overlay-pane` / `.cdk-overlay-backdrop` / `.cdk-global-scrollblock`
 * rules sit at **top level, un-`.ds`-scoped** — unlike the dialog overrides they therefore reach a
 * bare CDK pane, which is exactly what a fly-in is. `.cdk-overlay-pane` there sets
 * `margin-top: 3px; margin-bottom: 3px`, which pushes a full-height panel past the viewport. This
 * class is what the library's own pane rules are scoped under, and pairing it with
 * `.cdk-overlay-pane` is what makes them win by specificity rather than by stylesheet order.
 */
export const CLARITY_FLY_IN_PANEL_CLASS = 'eff-clarity-fly-in-panel';
